// extracted by mini-css-extract-plugin
export default {"container":"Legend_container__iJ9qx","legend-row":"Legend_legend-row__LRhGn","legend":"Legend_legend__Q4Gm9","label-row":"Legend_label-row__BhAD-","label":"Legend_label__DZVqx"};